import React, { Component } from "react";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import Button from "../../../../modules/commons/Button";
import IndentUnitBelumProsesFilter from "./indentUnitBelumProsesFilter";
import IndentUnitBelumProsesModifying from "./indentUnitBelumProsesModifying";
import { formGroup, printPDF } from "./config";
import { searchOptions, tableColumns } from "../config";
import SimplePrintButton from "../../../../modules/SimplePrintButton";
import * as R from "ramda";
import { fetchDataAsync } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import {saveAs} from 'file-saver'
class IndentUnitBelumProsesTable extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const { page, rowsPerPage } = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        ...tableColumns,
        {
            name: "indentNo",
            label: "Aksi",
            options: {
                customBodyRender: (val) => (
                    <SimpleButton
                        category="action_button"
                        styles={this.props.userAccess?.updateAccess&&{color:'red'}}
                        icon={<i className="fa fa-lw fa-pencil-alt" />}
                        onClick={() => this.handleModifyingVisibility(val)}
                        disabled={!this.props.userAccess?.updateAccess}
                    />
                ),
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            profileClass: this.clContentPopup,
            openPrint: false,
            detail: {
                id: "",
                visible: false,
            },
            filterVisible: false,
        };
    }

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleModifyingVisibility = (id) => {
        if (R.isNil(id)) {
            this.props.refetch();
        }
        this.setState((prevValue) => ({
            ...prevValue,
            detail: {
                id: id,
                visible: !prevValue.detail.visible,
            },
        }));
    };

    handleChangePage = (tableState) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    handleRefresh = () =>{
        this.setState((prevValue) => ({
          ...prevValue,
          filterData: {},
        }));
    }

    handlePrint = (type) => {
        if(type === "excel"){
            return this.handleGenerateExcel()
        }
        return this.handlePrintPDF()
    }

    handleGenerateExcel = async () => {
        const { setError, onSetState } = this.props;
        onSetState(prev=>({
            ...prev,
            loading:true
        }));

        const kodeCabang = this.props.state.kodeCabang?.value
    
        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_REPORT").generateExcelIndentUnit,
            setError: setError,
            menuName: "Indent Unit - Belum Proses",
            args: {
                kodeCabang: kodeCabang
            },
        });
    
        onSetState(prev=>({
            ...prev,
            loading: false
        }));
    
        if (res?.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `MonitoringIndent_${kodeCabang}.xlsx`);
      }
    };
    
    handlePrintPDF = async () => {
      const { setError, onSetState } = this.props;
      
      onSetState((prev) => ({
        ...prev,
        loading: true,
      }));

      const kodeCabang = this.props.state.kodeCabang?.value;

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").printPDFIndentUnit,
        setError: setError,
        menuName: "Indent Unit - Belum Proses",
        args: {
          kodeCabang: kodeCabang,
        },
      });

      onSetState((prev) => ({
        ...prev,
        loading: false,
      }));

      if (res?.ok) {
        printPDF(res.data);
      }
    };

    render() {
        return (
            <>
                <FlexView
                    vAlignContent="center"
                    hAlignContent="right"
                    className="margin-top-15px margin-bottom-15px"
                >
                    <FlexView
                        vAlignContent="center"
                        hAlignContent="right"
                        style={{ gap: "10px", marginRight: "20px" }}
                    >
                        <SimpleDDL
                            id="select_options_code_name_varian"
                            placeholder="Kd/Nm. Varian"
                            box="search"
                            containerclassname="margin-bottom-none width width-250px"
                            isClearable
                            options={searchOptions}
                            value={this.props.state.searchData?.key || null}
                            onChange={(value) =>
                                this.props.onSetState((prevValue) => ({
                                    ...prevValue,
                                    searchData: {
                                        key: typeof value === 'string'? value?.toUpperCase(): value,
                                    },
                                }))
                            }
                        />
                        <SimpleInput
                            placeholder="Text yang dicari"
                            containerclassname="margin-bottom-none"
                            readOnly={!this.props.state.searchData?.key}
                            value={this.props.state.searchData?.value}
                            onChange={({ target }) =>
                                this.props.onSetState((prevValue) => ({
                                    ...prevValue,
                                    searchData: {
                                        ...prevValue.searchData,
                                        value: target.value.toUpperCase(),
                                    },
                                }))
                            }
                        />
                        <SimpleButton
                            className="margin-left-none"
                            onClick={this.props.onSearch}
                            disabled={!this.props.state.searchData?.key}
                        >
                            Cari
                        </SimpleButton>
                    </FlexView>
                    <Button
                        type="button"
                        className="btn background-red"
                        onClick={this.handleFilterVisibility}
                    >
                        <span>
                            <i className="fa fa-qrcode"></i>
                        </span>
                    </Button>
                </FlexView>
                <SimpleDataTable
                    data={this.props.state.dataTable}
                    columns={this.tableColumns}
                    page={this.props.state.pagination.page - 1}
                    rowsPerPage={this.props.state.pagination.limit}
                    toCount={this.props.state.pagination.totalData}
                    options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                    footerAdditionalButtons={
                        <FlexView>
                            {this.props.userAccess?.createAccess &&
                                <SimpleButton onClick={() => this.handleModifyingVisibility("")}>
                                    <span>
                                        <i className="fa fa-plus margin-right-10px"></i>
                                    </span>
                                    Tambah Data
                                </SimpleButton>
                            }
                            <SimplePrintButton
                                text="Cetak"
                                toPdf
                                toExcel
                                onPrint={this.handlePrint}
                            />
                        </FlexView>
                    }
                />
                {this.state.filterVisible && (
                    <IndentUnitBelumProsesFilter
                        state={this.props.state}
                        visible={this.state.filterVisible}
                        onSubmit={this.props.onSubmitFilter}
                        onSetState={this.props.onSetState}
                        onClickClose={this.handleFilterVisibility}
                    />
                )}
                {this.state.detail.visible && (
                    <IndentUnitBelumProsesModifying
                        formGroup={formGroup}
                        kodeCabang={this.props.state.kodeCabang?.value}
                        detail={this.state.detail}
                        onRefresh={this.handleRefresh}
                        onClickClose={this.handleModifyingVisibility}
                    />
                )}
            </>
        );
    }
}

export default IndentUnitBelumProsesTable;
